import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject } from 'rxjs';
import { filter, first, takeUntil } from 'rxjs/operators';

import {
  AuthStore,
  BackendStorageStore,
  BookingStore,
  InstallationsStore,
  RemoteConfigStore,
  storageSessionsKeys,
  VkOrgCountry,
} from '@store';

import { RemoteConfigBanners } from '@vi-iot/client';

@Component({
  selector: 'app-installation-dashboard',
  templateUrl: './installation-dashboard.component.html',
  styleUrls: ['./installation-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationDashboardComponent implements OnInit, OnDestroy {
  isHardwareBundlingAvailable: boolean;
  isAllowedUser: boolean;
  isUserFromGermanyOrAustria: boolean;
  companyNameLengthLimit = 60;
  roadshowBanner = RemoteConfigBanners.RoadShow;
  testiegerBanner = RemoteConfigBanners.Testieger;
  isNotAbleToHandleAllRequestsBannerVisible =
    RemoteConfigBanners.isNotAbleToHandleAllRequestsBannerVisible;
  vitoconnectIssueBanner = RemoteConfigBanners.vitoconnectIssueBanner;
  vitoconnectLink: string;
  bannerForEndCustomer = RemoteConfigBanners.isBannerForEkUserVisible;
  advertisingBannerForDeAndAu = RemoteConfigBanners.advertisingBannerForDeAndAu;

  @Input() companyName;

  readonly advertBannerLink =
    'https://live.viessmann-climatesolutions.com/de/akademie-service.html';
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public authStore: AuthStore,
    public remoteConfigStore: RemoteConfigStore,
    public bookingStore: BookingStore,
    public installationsStore: InstallationsStore,
    private cdr: ChangeDetectorRef,
    public backendStorageStore: BackendStorageStore
  ) {}

  ngOnInit(): void {
    this.remoteConfigStore.isHardwareBundlingAvailable$
      .pipe(first())
      .subscribe((isHardwareBundlingAvailable) => {
        this.isHardwareBundlingAvailable = isHardwareBundlingAvailable;

        if (isHardwareBundlingAvailable) {
          this.bookingStore.getContingentSubscriptions();
        }
      });

    this.remoteConfigStore.showBanner(
      localStorage.getItem(this.roadshowBanner) === 'true',
      this.roadshowBanner
    );

    this.remoteConfigStore.showBanner(
      localStorage.getItem(this.testiegerBanner) === 'true',
      this.testiegerBanner
    );

    this.authStore
      .getVkorg()
      .pipe(
        takeUntil(this.ngUnsubscribe$),
        filter((vkorg: string) => !!vkorg)
      )
      .subscribe((vkorg: string) => {
        if (vkorg.includes(VkOrgCountry.Germany)) {
          this.vitoconnectLink =
            'https://partnerportal.viessmann-climatesolutions.com/de/de/informieren/neuigkeiten/2023/support-und-service/vitoconnect--problem-bei-der-konnektivierung.html';
        } else if (vkorg.includes(VkOrgCountry.Austria)) {
          this.vitoconnectLink =
            'https://partnerportal.viessmann-climatesolutions.com/at/de/informieren/vitoconnect--problem-bei-der-konnektivierung.html';
        }
        this.isAllowedUser = vkorg.includes(VkOrgCountry.Germany);
        this.isUserFromGermanyOrAustria =
          vkorg.includes(VkOrgCountry.Germany) || vkorg.includes(VkOrgCountry.Austria);
        this.cdr.markForCheck();
      });

    this.backendStorageStore.getKeyValue(storageSessionsKeys.ADVERT_BANNER_KEY);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onBannerClose(banner: RemoteConfigBanners): void {
    this.remoteConfigStore.closeBanner(banner);
  }

  onAdvertBannerClose(): void {
    this.backendStorageStore.setKeyValue(storageSessionsKeys.ADVERT_BANNER_KEY, { data: false });
  }
}
